import { UserOrSupplier } from "@graphql/types";
import React, { FC } from "react";
import { t } from "@helpers/translate";

interface Props {
  user: UserOrSupplier;
  className?: string;
}

export const DidYouLikeMyArticleAd: FC<Props> = ({ user, className = "" }) => {
  const utm = "?utm_medium=post&utm_source=did-you";
  return (
    <div className={`blog-content my-10 ${className}`}>
      <h3 className="text-4xl">Did you like my article?</h3>
      <p className="text-lg leading-snug mb-10">
        You can{" "}
        <a
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
          href={`${user.url}/message${utm}`}
        >
          send me a message
        </a>{" "}
        to get a customized itinerary and quotation for an unforgettable
        experience.
        <br />
        <br />
        I&apos;ll be waiting for you, so please{" "}
        <a
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
          href={`${user.url}${utm}`}
        >
          check my profile
        </a>{" "}
        and get your trip plan now
      </p>
    </div>
  );
};

export default DidYouLikeMyArticleAd;
